/* ADA remediation helpers (LevelAccess scan 2026-08-09). */
(function () {
  'use strict';

  /* Off-canvas slideout drawers (mobile nav, cart, filters) stay in the
     accessibility tree while closed, duplicating every nav link for screen
     readers and keyboard users. Keep closed drawers inert. */
  function syncSlideouts() {
    document.querySelectorAll('aside.slideout').forEach(function (drawer) {
      if (drawer.classList.contains('slideout--active')) {
        drawer.removeAttribute('inert');
      } else {
        drawer.setAttribute('inert', '');
      }
    });
  }

  /* Flickity makes its carousel viewport a focusable <div tabindex="0">
     with no role or accessible name (WCAG 4.1.2). */
  function labelCarousels() {
    document.querySelectorAll('.flickity-enabled[tabindex]:not([role])').forEach(function (el) {
      el.setAttribute('role', 'region');
      if (!el.hasAttribute('aria-label')) {
        el.setAttribute('aria-label', 'Carousel');
      }
    });
  }

  /* The OneTrust banner's Cookie Policy link ships an aria-label that omits
     its visible text (WCAG 2.5.3 Label in Name). The link needs no override;
     its visible text plus the new-tab context is the right name. */
  function fixCookiePolicyLink() {
    document.querySelectorAll('a.ot-cookie-policy-link[aria-label]').forEach(function (link) {
      var visible = link.textContent.trim();
      if (visible && link.getAttribute('aria-label').indexOf(visible) === -1) {
        link.setAttribute('aria-label', visible + ' - more information about your privacy, opens in a new tab');
      }
    });
  }

  /* Keep the header cart link's accessible name in sync with the live count
     so the visible number is always part of the name (WCAG 2.5.3). */
  function syncCartLabel() {
    document.querySelectorAll('a.cart-icon[aria-label]').forEach(function (link) {
      var count = link.querySelector('.js-cart-count');
      if (count) {
        var n = count.textContent.trim() || '0';
        link.setAttribute('aria-label', 'Cart, ' + n + ' items');
      }
    });
  }

  function run() {
    /* Lift inert before the theme's open handler tries to move focus in. */
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.js-slideout-open, [data-wau-slideout-target]')) {
        document.querySelectorAll('aside.slideout[inert]').forEach(function (drawer) {
          drawer.removeAttribute('inert');
        });
      }
    }, true);

    syncSlideouts();
    labelCarousels();
    fixCookiePolicyLink();
    syncCartLabel();
    new MutationObserver(function (mutations) {
      var classChange = false;
      var treeChange = false;
      mutations.forEach(function (m) {
        if (m.type === 'attributes') classChange = true;
        if (m.type === 'childList') treeChange = true;
      });
      if (classChange) syncSlideouts();
      if (treeChange) {
        labelCarousels();
        fixCookiePolicyLink();
        syncCartLabel();
      }
    }).observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
